import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col, Flex, Affix, ConfigProvider, theme } from 'antd';

import ProgressBarLoading from 'Components/commonComponents/ProgressBarLoading';

import { LAYOUT_HEADER_HEIGHT, LAYOUT_VERTICAL_PADDING } from '@shared/constants/layout';
import LeftSidebar from './components/LeftSidebar';
import Main from './components/Main';
import { QuotationsComparatorHeader } from './components/Header';

const QuotationComparatorPageView = ({
  quotationData = {},
  loading = false,
  // insuranceCarriersErrors = [],
  // insuranceCarriersAlerts = [],
  // insuranceCarriersDataDifferences = [],
  showProgressBarLoader = false,
}) => {
  const { token: themeToken } = theme.useToken();

  return (
    <Flex vertical gap={LAYOUT_VERTICAL_PADDING} style={{ flex: 1, width: 'calc(100% + 3vw)', marginInline: '-1.5vw' }}>
      {showProgressBarLoader && <ProgressBarLoading infinite fixedBelowHeader />}
      <Affix offsetTop={LAYOUT_HEADER_HEIGHT}>
        <QuotationsComparatorHeader quotation={quotationData} loading={loading} />
      </Affix>
      <ConfigProvider
        theme={{
          token: { colorBorderSecondary: `${themeToken.colorPrimary}33` }, // 20% de opacidad (afecta a Divider, bordes de Card y otros componentes)
        }}
      >
        <Row
          gutter={[16, 16]}
          style={{ flex: 'auto' }} // Hace que el Row ocupe todo el espacio disponible verticalmente
        >
          <Col flex='1 0 20em'>
            <LeftSidebar
              // insuranceCarriersErrors={insuranceCarriersErrors}
              // insuranceCarriersAlerts={insuranceCarriersAlerts}
              // insuranceCarriersDataDifferences={insuranceCarriersDataDifferences}
              loading={loading}
            />
          </Col>
          <Col flex='1000 1 0'>
            <Main quotation={quotationData} loading={loading} parentBottomPadding={LAYOUT_VERTICAL_PADDING} />
          </Col>
        </Row>
      </ConfigProvider>
    </Flex>
  );
};

QuotationComparatorPageView.propTypes = {
  quotationData: PropTypes.shape({}),
  loading: PropTypes.bool,
  // insuranceCarriersErrors: PropTypes.array,
  // insuranceCarriersAlerts: PropTypes.array,
  // insuranceCarriersDataDifferences: PropTypes.array,
  showProgressBarLoader: PropTypes.bool,
};

export default QuotationComparatorPageView;
